<template>

  <span v-if="folder.limit_date" >
    <v-tooltip top>
    <v-chip slot="activator" class="align-center">
      <span>
        <v-icon size="20" class="mr-2 mb-0">mdi-clock-fast</v-icon>
      </span>
      <span>
        {{ folder.limit_date | formatDate }}
      </span>
    </v-chip>
      Data limite da tramitação
    </v-tooltip>

  </span>
  <span v-else-if="folder.last_transaction">
    <v-tooltip top>
      <v-chip slot="activator" class="align-center">
        <span>
          <v-icon size="20" class="mr-2 mb-0">mdi-clock-fast</v-icon>
        </span>
        <span>
          {{ folder.last_transaction.created_at | formatDateWithHours }}
        </span>
      </v-chip>
      Última Tramitação
    </v-tooltip>
  </span>
  <span v-else class="align-center">
    <v-tooltip top>
      <v-chip slot="activator"> Não tramitado</v-chip>
      Processo não tramitado
    </v-tooltip>

  </span>

</template>

<script>
export default {
  name: 'term-component',
  props: ['folder'],
  data() {
    return {};
  },
  methods: {},
  computed: {},
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/inbox/TermComponent.vue